const es = {
    'security.login.error': 'Usuario o contraseña incorrectos',
    'security.token.error': 'Token incorrecto',
    'security.login.email': 'Email',
    'security.login.password': 'Contraseña',
    'security.login.login': 'Iniciar sesión',
    'security.login.loginwith': 'Entrar con',
    'security.login.loginOld': 'Iniciar sesión con intranet antigua',
    'security.login.forgotPassword': '¿Has olvidado tu contraseña?',
    'security.forgotPassword.title': 'Restablecer contraseña',
    'security.forgotPassword.description': 'Introduce tu correo corporativo y te enviaremos un enlace para restablecer tu contraseña.',
    'security.forgotPassword.send': 'Enviar enlace',
    'security.forgotPassword.cancel': 'Cancelar',
    'security.forgotPassword.success': 'Si el correo está registrado en el sistema, recibirás un enlace para restablecer tu contraseña. Revisa también tu bandeja de correo no deseado.',
    'security.forgotPassword.error': 'Se ha producido un error al solicitar el restablecimiento. Inténtalo de nuevo.',
    'security.resetPassword.title': 'Restablecer contraseña',
    'security.resetPassword.subtitle': 'Introduce tu nueva contraseña para la intranet.',
    'security.resetPassword.newPassword': 'Nueva contraseña',
    'security.resetPassword.confirmPassword': 'Confirmar nueva contraseña',
    'security.resetPassword.submit': 'Actualizar contraseña',
    'security.resetPassword.success': 'Tu contraseña ha sido restablecida correctamente. Ya puedes iniciar sesión con tu nueva contraseña.',
    'security.resetPassword.error': 'No se ha podido restablecer la contraseña. El enlace puede haber caducado o no ser válido.',
    'security.resetPassword.mismatch': 'Las contraseñas no coinciden.',
    'security.resetPassword.tooShort': 'La contraseña debe tener al menos 8 caracteres.',
    'security.resetPassword.invalidToken': 'El enlace de recuperación es inválido o ha caducado.',
    'security.resetPassword.backToLogin': 'Volver al inicio de sesión',
    'security.resetPassword.requestNewLink': 'Solicitar nuevo enlace',
};

export default es;